module.exports = __webpack_public_path__ + "img/trusted-globe.5c7a374.svg";